<template>
  <b-tabs content-class="mt-3">
    <b-tab title="Search"><RevealImageFinder @image-added="handleConfirm" @cancel="cancel" :position="position" /></b-tab>
    <b-tab title="Upload" lazy>
      <RevealImageUploader v-if="userId" @image-created="handleConfirm" :position="position" @cancel="cancel" />
      <div v-else>
        <p class="lead">Join Ambiki to add custom images for the image reveal subtask.</p>
        <b-button href="/signup">Sign up</b-button>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapState } from 'vuex';
import RevealImageFinder from './RevealImageFinder.vue';
import RevealImageUploader from './RevealImageUploader.vue';

export default {
  components: { RevealImageFinder, RevealImageUploader },

  props: {
    position: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapState(['userId']),
  },

  methods: {
    cancel() {
      this.$emit('close-adder');
    },

    handleConfirm() {
      this.$emit('close-adder');
    },
  },
};
</script>
